/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */
(function () {
   'use strict';

   angular
         .module('com.vmware.vsphere.client.networkLibUi')
         .service('physicalAdaptersListService', physicalAdaptersListService);

   physicalAdaptersListService.$inject = ['dataService', 'i18nService'];

   var physicalAdapterItemsProperty = "pnic:physicalAdapterItems";
   var physicalAdapterDetailsItemProperty = "pnic:physicalAdapterItemDetails";
   var unclaimedPhysicalAdaptersProperty = "pnic:unclaimedPhysicalAdapters";
   var physicalAdaptersWithDetails = "pnic:physicalAdaptersWithDetails";
   var proxySwitchUplinkData = "proxyswitch:getProxySwitchUplinkData";

   function physicalAdaptersListService(dataService, i18nService) {

      return {
         getPhysicalAdapterItems: function(hostId) {
            return dataService.getProperties(hostId, [physicalAdapterItemsProperty], {
                  skipErrorInterceptor: true
               }).then(function(dataServiceResponse) {
                  var physicalAdapterItems = dataServiceResponse
                        ? dataServiceResponse[physicalAdapterItemsProperty]
                        : [];

                  physicalAdapterItems = physicalAdapterItems || [];
                  var currentPnicIndex = 0;

                  physicalAdapterItems.forEach(function(pnicItem) {
                     if (!pnicItem.virtualSwitch) {
                        pnicItem.virtualSwitch = {
                           switchName: i18nService
                                 .getString('NetworkUi', 'NetworkUtil.noData')
                        };
                     }

                     pnicItem.wakeOnLanSupportedLabel = pnicItem.wakeOnLanSupported
                           ? i18nService.getString('NetworkUi', 'PnicView.labelYes')
                           : i18nService.getString('NetworkUi', 'PnicView.labelNo');
                     pnicItem.actualSpeedLabel = pnicItem.actualSpeed
                           ? i18nService.getString('NetworkUi', 'PnicView.speedMb', pnicItem.actualSpeed)
                           : i18nService.getString('NetworkUi', 'PnicView.down');
                     pnicItem.configuredSpeedLabel = !pnicItem.configuredSpeed || pnicItem.configuredSpeed === 0
                           ? i18nService.getString('NetworkUi', 'PnicView.autonegotiate')
                           : i18nService.getString('NetworkUi', 'PnicView.speedMb', pnicItem.configuredSpeed);

                     if(pnicItem.sriovInfo && pnicItem.sriovInfo.sriovCapable) {
                        if (pnicItem.sriovInfo.sriovEnabled) {
                           pnicItem.sriovStatusLabel =
                                 i18nService.getString('NetworkUi', 'Sriov.status.enabled');
                           pnicItem.sriovNumVirtuanFunctionsLabel =
                                 pnicItem.sriovInfo.numVirtualFunctionsRequested ===
                                 pnicItem.sriovInfo.numVirtualFunction
                                       ? pnicItem.sriovInfo.numVirtualFunction
                                       : i18nService.getString('NetworkUi', 'Sriov.vf.mixedFormat',
                                             pnicItem.sriovInfo.numVirtualFunctionsRequested,
                                             pnicItem.sriovInfo.numVirtualFunction);
                        } else {
                           pnicItem.sriovStatusLabel =
                                 i18nService.getString('NetworkUi', 'Sriov.status.disabled');
                           pnicItem.sriovNumVirtuanFunctionsLabel =
                                 i18nService.getString('NetworkUi', 'Sriov.vf.na');
                        }
                     } else {
                        pnicItem.sriovStatusLabel = i18nService.getString(
                              'NetworkUi', 'Sriov.status.notSupported');
                        pnicItem.sriovNumVirtuanFunctionsLabel = i18nService.getString(
                              'NetworkUi', 'Sriov.vf.na');
                     }

                     pnicItem.pnicIndex = currentPnicIndex++;
               });

               return physicalAdapterItems;
            });
         },

         getPhysicalAdapterDetailsItem: function(hostId, pnicName) {
            var params = [{
               propertyName: physicalAdapterDetailsItemProperty,
               parameterType: 'java.lang.String',
               parameter: pnicName
            }];
            return dataService
                  .getProperties(hostId, [physicalAdapterDetailsItemProperty], {
                     propertyParams: params
                  })
                  .then(function (response) {
                     if (response && response[physicalAdapterDetailsItemProperty]) {
                        return response[physicalAdapterDetailsItemProperty];
                     }
                     return null;
                  });
         },

         getUnclaimedPhysicalAdapters: function (hostId) {
            return dataService.getProperties(hostId, [unclaimedPhysicalAdaptersProperty])
               .then(function (response) {
                  if (response && response[unclaimedPhysicalAdaptersProperty]) {
                     return response[unclaimedPhysicalAdaptersProperty];
                  }
                  return null;
               });
         },

         getPhysicalAdaptersWithDetails: function (hostId, vSwitchName) {
            var params = [{
               propertyName: physicalAdaptersWithDetails,
               parameterType: 'java.lang.String',
               parameter: vSwitchName
            }];
            return dataService.
               getProperties(hostId, [physicalAdaptersWithDetails], {
                     propertyParams: params
               })
               .then(function (response) {
                  if (response && response[physicalAdaptersWithDetails]) {
                     return response[physicalAdaptersWithDetails];
                  }
                  return null;
               });
         },

         getProxySwitchUplinkData: function (hostId, dvsRef, proxySwitchKey) {
            var hostSwitchSpec = {
               dvsRef: dvsRef,
               proxySwitchKey: proxySwitchKey
            };

            var params = [{
               propertyName: proxySwitchUplinkData,
               parameterType: 'com.vmware.vsphere.client.h5.network.host.proxyswitch.spec.ProxySwitchInfoSpec',
               parameter: hostSwitchSpec
            }];
            return dataService.
                  getProperties(hostId, [proxySwitchUplinkData], {
                     propertyParams: params
                  })
                  .then(function (response) {
                     if (response && response[proxySwitchUplinkData]) {
                        return response[proxySwitchUplinkData];
                     }
                     return null;
                  });
         }
      };
   }
})();
